<template>
    <div class="stamp-exchange-confirm">
        <!-- 商品信息 -->
        <div class="good-bg">
            <img class="good-icon" :src="commodityPicUrl" alt="商品图片" />
            <div class="good-info">
                <div class="title">{{ name }}</div>
                <div class="number">数量x1</div>
                <div class="stamps"><span style="font-size: 20px;margin-right: 5px;">{{ stamps }}</span>印花</div>
            </div>
        </div>

        <!-- 印花信息 -->
        <div class="stamps-bg">
            <div class="stamps-item">
                <div class="title">使用印花</div>
                <div class="value">{{ stamps }}</div>
            </div>
            <div class="stamps-item" style="border-bottom: none;">
                <div class="title">兑换数量</div>
                <div class="value">{{ exchangeNum }}</div>
            </div>
            <div class="stamps-item" style="border-bottom: none;">
                <div class="title">剩余印花</div>
                <div class="value">{{ userStamps - stamps }}</div>
            </div>
        </div>

        <!-- 验证信息 -->
        <div class="info-bg">
            <div class="info-item">
                <div class="name">手机号</div>
                <input class="input" type="tel" v-model="mobile" maxlength="11" disabled placeholder="手机号" />
            </div>
            <div class="info-item" style="border-bottom: none;">
                <div class="name">验证码</div>
                <input class="input" style="width: 40%;" type="number" v-model="code" maxlength="6" minlength="6" placeholder="短信验证码" />
                <button v-if="isCaptcha" class="code-btn" @click="ClerkVerificationCode">获取验证码</button>
                <button v-if="!isCaptcha" class="code-btn rest">
                    {{ count }}s
                </button>
            </div>
        </div>

        <div style="height: 150px; width: 100%"></div>

        <!-- 使用规则说明 -->
        <div class="rules-bg">
            <div class="rules-header">
                <span class="rules-title">兑换券使用规则</span>
            </div>
            <div class="rules-content">
                <div class="rule-item">
                    <span class="rule-dot">•</span>
                    <span class="rule-text"><span class="emphasis">使用要求：</span>【印花兑换券】需与益力多产品（至少1排）组合线上下单时使用</span>
                </div>
                <div class="rule-item">
                    <span class="rule-dot">•</span>
                    <span class="rule-text"><span class="emphasis">有效期说明：</span>【印花兑换券】有效期10天，逾期未使用将失效，届时将退还兑换时扣除的印花</span>
                </div>
            </div>
            <div class="agree-section">
                <div class="checkbox" @click="toggleAgree">
                    <div class="stamp-checkbox">
                        <div class="checkbox-wrapper" v-if="isAgreed">
                            <img src="../../assets/check_box_24px_rounded.png" alt="" style="width: 20px; height: 20px;">
                        </div>
                        <div class="checkbox-border" v-else></div>
                    </div>
                    <span class="agree-text">我已阅读并同意以上规则</span>
                </div>
            </div>
        </div>

        <!-- 兑换按钮 -->
        <div class="exchange-bg">
            <button class="exchange-btn" @click="exchangeBtn" :disabled="!isAgreed">{{isAgreed ? '确定兑换' : '请同意上述规则后，再兑换' }}</button>
        </div>

        <!-- 成功弹窗 -->
        <base-dialog v-if="show" :title="title" width="80%" display="none">
            <div class="message">{{ name }}兑换券已生成，请下次下单时使用！</div>
            <div class="tip-emphasis" v-if="!isStamp">该礼品券有效期{{ validity }}天，请尽快使用！</div>
            <div class="tip-emphasis" v-if="!isStamp">过期时间:{{ expireTime }}</div>
            <div class="dialog-buttons">
                <button class="tip-cancel" @click="stampShopDetail">查看</button>
                <button class="tip-ok" @click="submit">确认</button>
            </div>
        </base-dialog>

        <!-- Toast 提示 -->
        <Toast ref="toast"></Toast>
    </div>
</template>

<script>
import { GetExchangeGoods, VerifyCode, stampExchange } from '../../api/StampShop'
import { memberDetail } from '../../api/Member'
import { parseTime } from '../../unitls'
import BaseDialog from '../../components/BaseDialog.vue'

export default {
    name: 'StampExchangeConfirm',
    components: {
        BaseDialog
    },
    data() {
        return {
            id: '',
            title: '兑换成功',
            name: '',
            show: false,
            stamps: '',
            exchangeNum: '1',
            mobile: '',
            code: '',
            userStamps: '',
            commodityPicUrl: '',

            isCaptcha: true,
            timer: null,
            count: '', // 发送验证码倒计时

            voucherId: '',
            expireTime: '',
            validity: '',
            isStamp: false,

            isAgreed: false,
        }
    },

    created() {
        this.id = this.$route.query.id
        this.userStamps = this.$route.query.userStamps
        this.loadDetail()
        this.getMobile()
    },

    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    },

    methods: {
        // Toast 提示方法
        toast(e) {
            this.$refs.toast.show(e, 1500);
        },

        // 发送验证码
        ClerkVerificationCode() {
            if (!this.mobile) {
                this.toast('电话号码不能为空')
                return
            }
            const telReg = /^1[3456789]\d{9}$/
            if (!telReg.test(this.mobile)) {
                this.toast('请输入正确的电话号码')
                return
            }

            VerifyCode({
                memberTel: this.mobile
            }).then(res => {
                if (res.code === this.$API_CODE.OK) {
                    const TIME_COUNT = 60
                    if (!this.timer) {
                        this.count = TIME_COUNT
                        this.isCaptcha = false
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--
                            } else {
                                this.isCaptcha = true
                                clearInterval(this.timer)
                                this.timer = null
                            }
                        }, 1000)
                    }
                    this.toast('验证码发送成功')
                } else {
                    this.toast(res.message)
                }
            }).catch(err => {
                console.error(err)
            })
        },

        // 加载商品详情
        loadDetail() {
            GetExchangeGoods({
                duiId: this.id,
                activityId: 1
            }).then(res => {
                if (res.code === this.$API_CODE.OK) {
                    this.name = res.data.productname
                    this.stamps = res.data.stampQuantity
                    this.commodityPicUrl = this.$store.state.app.API_URL + res.data.imgurl
                } else {
                    this.toast(res.message)
                }
            }).catch(err => {
                console.error(err)
            })
        },

        // 获取会员信息
        getMobile() {
            memberDetail().then(res => {
                if (res.code === this.$API_CODE.OK) {
                    this.mobile = res.data.mobile || res.data.phoneNumber
                }
            }).catch(err => {
                console.error(err)
            })
        },

        // 兑换按钮
        exchangeBtn() {
            if (!this.code) {
                this.toast('请输入验证码')
                return
            }

            stampExchange({
                stampShopActivityId: 1,
                duiId: this.id,
                exchangeNumber: 1,
                captcha: this.code
            }).then(res => {
                if (res.code === this.$API_CODE.OK) {
                    this.show = true
                    this.voucherId = res.data.id
                    this.expireTime = parseTime(res.data.expirationTime)
                    this.validity = res.data.validity
                } else {
                    this.toast(res.message)
                }
            }).catch(err => {
                console.error(err)
            })
        },

        // 确认按钮
        submit() {
            this.show = false
            this.$router.replace('/stampShop')
        },

        // 查看兑换券详情
        stampShopDetail() {
            this.$router.push({
                path: '/stampShopDetail',
                query: {
                    id: this.voucherId,
                    type: 'voucher'
                }
            })
        },
         // 切换同意状态
        toggleAgree() {
            this.isAgreed = !this.isAgreed
        },
    }
}
</script>

<style scoped lang="scss">
.stamp-exchange-confirm {
    background: #F7F7F7 !important;
    background-color: #F7F7F7 !important;
    min-height: 100vh;
    padding-bottom: 20px;
}

.good-bg {
    width: 92%;
    margin: 12px auto;
    padding: 15px;
    background: #ffffff;
    border-radius: 15px;
    height: 116px;

    .good-icon {
        width: 86px;
        height: 86px;
        float: left;
    }

    .good-info {
        height: 86px;
        float: left;
        width: 63%;
        margin-left: 15px;

        .title {
            text-align: left;
            color: #666666;
            font-size: 15px;
            height: 65px;
        }

        .number {
            float: left;
            color: #999999;
            font-size: 12px;
        }

        .stamps {
            float: right;
            color: #D33A35;
            font-size: 12px;
        }
    }
}

.stamps-bg {
    width: 92%;
    margin: 12px auto;
    padding: 15px;
    background: #ffffff;
    border-radius: 15px;

    .stamps-item {
        color: #333333;
        font-size: 15px;
        border-bottom: 1px solid #DBDBDB;
        height: 40px;
        line-height: 40px;

        .title {
            float: left;
        }

        .value {
            float: right;
        }
    }
}

.info-bg {
    background: #ffffff;
    border-radius: 15px;
    width: 92%;
    margin: 12px auto;
    padding: 10px;

    .info-item {
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        border-bottom: 1px solid #DBDBDB;
        position: relative;

        .name {
            float: left;
            width: 60px;
            margin-right: 15px;
        }

        .input {
            width: 50%;
            height: 50px;
            border: 0;
            outline: none;
            font-size: 15px;
        }

        .code-btn {
            position: absolute;
            top: 0;
            right: 0;
            width: 90px;
            height: 30px;
            line-height: 30px;
            padding: 0;
            background: #D33A35;
            color: #ffffff;
            font-size: 14px;
            border-radius: 25px;
            margin-top: 10px;
            border: none;
            cursor: pointer;

            &:active {
                opacity: 0.8;
            }
        }

        .rest {
            background-color: #757575;
        }

        .tui-picker-content {
            width: 75%;
            height: 50px;
            margin-left: 75px;
            font-size: 15px;

            .myPickerProv {
                width: 45%;
                font-size: 1rem;
                border-radius: 5px;
                text-align: left;
                float: left;
                font-size: 0.9rem;
            }

            .myPickerCity {
                width: 45%;
                font-size: 1rem;
                border-radius: 5px;
                text-align: left;
                float: left;
                font-size: 0.9rem;
            }

            .picker-input {
                height: 50px;
                float: left;
                width: 40%;
            }

            .picker-arrow {
                width: 22px;
                height: 22px;
                float: right;
                margin-top: 14px;
            }
        }
    }
}

.exchange-bg {
    width: 90%;
    position: fixed;
    left: 5%;
    right: 5%;
    bottom: 20px;
    z-index: 999;

    .exchange-btn {
        background: #D33A35;
        border-radius: 25px;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding: 0;
        color: #ffffff;
        font-size: 20px;
        border: none;
        cursor: pointer;

        &:active {
            opacity: 0.8;
        }
    }
}

/* 弹窗样式 */
.message {
    font-size: 16px;
    color: #333;
    text-align: center;
    margin-bottom: 10px;
    font-weight: 500;
}

.tip {
    font-size: 13px;
    color: #ed3f14;
    text-align: center;
    margin-bottom: 8px;
}

.tip-emphasis {
    font-size: 16px;
    color: #ed3f14;
    text-align: center;
    margin-bottom: 7px;
}

.dialog-buttons {
    display: flex;
    justify-content: space-around;
    margin-top: 15px;
    gap: 10px;
}

.tip-cancel {
    flex: 1;
    background: linear-gradient(135deg, #409eff, #66b1ff);
    color: #ffffff;
    font-size: 15px;
    font-weight: 500;
    border-radius: 5px;
    border: none;
    padding: 10px 0;
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
    cursor: pointer;

    &:active {
        opacity: 0.8;
    }
}

.tip-ok {
    flex: 1;
    background: linear-gradient(135deg, #ea2d53, #f56c6c);
    color: #ffffff;
    font-size: 15px;
    font-weight: 500;
    border-radius: 5px;
    border: none;
    padding: 10px 0;
    box-shadow: 0 2px 6px rgba(234, 45, 83, 0.3);
    cursor: pointer;

    &:active {
        opacity: 0.8;
    }
}


/* 使用规则背景 */
.rules-bg {
    width: 86%;
    margin: 12px auto;
    padding: 15px;
    background: #ffffff;
    border-radius: 15px;
    border: 1px solid #ffebee;
}

/* 规则头部 */
.rules-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
}

.rules-icon {
    font-size: 24px;
    margin-right: 10px;
}

.rules-title {
    font-size: 16px;
    font-weight: 600;
    color: #D33A35;
}

/* 规则内容 */
.rules-content {
    text-align: left;
    margin-bottom: 15px;
}

.rule-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    line-height: 1.6;
}

.rule-item:last-child {
    margin-bottom: 0;
}

.rule-dot {
    color: #D33A35;
    font-size: 14px;
    margin-right: 8px;
    flex-shrink: 0;
}

.rule-text {
    font-size: 14px;
    color: #666666;
    flex: 1;
}

.rule-text .emphasis {
    color: #333333;
    font-weight: 500;
}

/* 同意区域 */
.agree-section {
    padding-top: 10px;
    border-top: 1px solid #f0f0f0;
}

.checkbox {
    display: flex;
    align-items: center;
}

/* checkbox样式 */
.stamp-checkbox {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
}

.checkbox-border {
    width: 20px;
    height: 20px;
    border: 2px solid #ea2d53;
    border-radius: 3px;
}

.checkbox-wrapper {
    width: 8px;
    height: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.agree-text {
    font-size: 13px;
    color: #666666;
}

/* 兑换按钮禁用状态 */
.exchange-bg .exchange-btn.disabled {
    background: #cccccc !important;
    color: #999999 !important;
}
</style>
